export const BINARY_OPTIONS = [
  {
    id: 'yes',
    name: 'yes',
    labelText: 'Yes',
  },
  {
    id: 'no',
    name: 'no',
    labelText: 'No',
  },
];
